import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { ProductIds, Roles } from "../constants";

function AuthGuard({ children, isPublic = false, role }) {
  const location = useLocation();
  const token = useSelector(
    (state) => state.auth.token || state.auth.guest_token || "",
  );
  const userRole = useSelector((state) => state.auth.role);
  console.log("🚀 ~ AuthGuard ~ userRole:", userRole);
  const navigate = useNavigate();

  const isValid = useMemo(() => {
    if (isPublic) {
      return true;
    }
    return !!token;
  }, [token, isPublic]);

  useEffect(() => {
    if (!token && location.pathname.includes("checkout")) {
      const currentUrl = location.pathname;
      console.log("Storing intended URL:", currentUrl);
      // Save the intended URL in Cookies
      Cookies.set(
        "intendedUrl",
        `${process.env.REACT_APP_WORD_PRESS_REDIRECT_URI}/pricing/`,
      );
    }

    if (isValid) {
      if (role !== "all" && role !== userRole) {
        if (userRole === Roles.PATIENT) {
          navigate("/patient_dashboard");
        } else if (userRole === Roles.DENTIST) {
          navigate("/dentist_portal");
        }
      }
    } else {
      if (token) {
        if (role !== "all" && role !== userRole) {
          if (userRole === Roles.PATIENT) {
            navigate("/patient_dashboard");
          } else if (userRole === Roles.DENTIST) {
            navigate("/dentist_portal");
          }
        }
      } else {
        navigate("/");
      }
      console.log("You are in wrong way");
    }
  }, [isValid, role, userRole, token, navigate, location.pathname]);

  return <>{isValid && children}</>;
}

export default AuthGuard;
